import { render, staticRenderFns } from "./VehicleChangeFrequencyComponent.vue?vue&type=template&id=9f4acfe8"
import script from "./VehicleChangeFrequencyComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleChangeFrequencyComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports